import Recaptcha from 'react-gcaptcha'
import styles from './Recaptcha.css'

export default class Captcha extends React.Component {
  constructor (props) {
    super(props)
    let {input} = this.props
    let {onChange} = input
    this.state = {
      onChange
    }
  }
  callback (key) {
    this.state.onChange(key)
  }

  loaded () {
  }

  render () {
    let {input, meta} = this.props
    let {touched, error} = meta
    return (
      <div className={styles['recaptcha']}>
        <Recaptcha {...input}
          sitekey='6LesGA4UAAAAAMQ4EgXcvuxeJOXdIo217ldryOms'
          onloadCallback={this.loaded}
          verifyCallback={this.callback.bind(this)}
        />
        <small className='error'>{touched ? error : ''}</small>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/pages/ForgotPassword/Captcha.js